
<v-toolbar color="primary">
  <v-btn :to="homeLink" icon>
    <v-icon>home</v-icon>
  </v-btn>
  <v-spacer></v-spacer>
  <img class="logo" src="/api/logo">
  <v-spacer></v-spacer>
  <v-toolbar-items class="toolbar-right">
    <v-btn-toggle v-if="activeLanguages.length > 1" v-model="currentLocale" class="lang-toggle" dense mandatory>
      <v-btn
          v-for="lang in activeLanguages"
          :key="lang.code"
          :title="lang.displayName"
          :value="lang.code"
          class="lang-btn"
          small
          text
      >
        <img :alt="lang.displayName" :src="flagSrc(lang.flag)" class="flag-icon"/>
      </v-btn>
    </v-btn-toggle>
    <v-btn :class="{hidden: ! hasImages}" text to="/basket">
      <v-badge bottom color="red" overlap>
        <template v-slot:badge color="white">{{ basketBadge }}</template>
        <v-icon>shopping_cart</v-icon>
      </v-badge>
    </v-btn>
  </v-toolbar-items>
</v-toolbar>
